<div>
  <form [class.blocked]="submitted && form.valid" (ngSubmit)="onSubmit(rewardsNumber.valid)" #registerForm="ngForm">

    <div class="form-para" [innerHtml]="'IHG.NAME' | translate:data"></div>
    <div class="form-para" [innerHtml]="'IHG.MP_ID' | translate:data"></div>
    <p [innerHtml]="'IHG.DESC' | translate"></p>
    <div class="form-group">
      <label for="rewardsNumber" [innerHtml]="'IHG.REWARD' | translate"></label>
      <div class="form-textbox" [ngClass]="{'invalid': form && rewardsNumber.invalid && firstSubmitted && (rewardsNumber.touched || rewardsNumber.pristine)}">
        <input [placeholder]="'IHG.REWARD_PH' | translate" name="rewardsNumber" [pattern]="ihgPattern" [ngModelOptions]="{standalone: true}" autocomplete="off" required name="rewardsNumber" type="text" [(ngModel)]="formModel.rewardsNumber" (keyup)="submitted=false;" #rewardsNumber="ngModel" />
        <div class="form-error" [hidden]="!(rewardsNumber.invalid && firstSubmitted)">
          <span></span>
          <span [innerHtml]="'IHG.REWARD_PH' | translate"></span>
        </div>
      </div>
    </div>

    <div class="form-hint" [innerHtml]="'IHG.HINT' | translate"></div>
    
    <div class="form-forgot">
      <a [href]="'IHG.FORGOT_LINK' | translate" target="_blank" [innerHtml]="'IHG.FORGOT' | translate"></a>
    </div>

    <div class="form-btn">
      <button tabindex=0 >
        <span [class.show]="loading">
          <svg class="form-loading" width="38" height="20" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
            <g fill="none" fill-rule="evenodd">
              <g transform="translate(1 1)" stroke-width="2">
                <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                <path d="M36 18c0-9.94-8.06-18-18-18">
                  <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                </path>
              </g>
            </g>
          </svg>
        </span>
        <span [class.show]="!loading" [innerHtml]="'IHG.CTA_BTN' | translate"></span>
      </button>
    </div>

    <div class="form-forgot">
      <a [href]="'IHG.JOIN_LINK' | translate" target="_blank" [innerHtml]="'IHG.JOIN' | translate"></a>
    </div>

    <a [href]="'CONSENTS.PRIVACY_POLICY_LINK' | translate" tabindex="0" class="info-terms" [attr.aria-label]="'CONSENTS.PRIVACY_POLICY_ARIA' | translate" [innerHtml]="'CONSENTS.PRIVACY_POLICY' | translate" target="_blank"></a>
    <div role="button" class="cookie-consent" tabindex="0" [innerHtml]="'CONSENTS.COOKIE_PREFS' | translate"></div>

  </form>
</div>